module.exports = __webpack_public_path__ + "static/media/12b_hero_desktop.8221134e.jpg";